import { render, staticRenderFns } from "./addClasses.vue?vue&type=template&id=7e338fb0&scoped=true&"
import script from "./addClasses.vue?vue&type=script&lang=js&"
export * from "./addClasses.vue?vue&type=script&lang=js&"
import style0 from "./addClasses.vue?vue&type=style&index=0&id=7e338fb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e338fb0",
  null
  
)

export default component.exports